"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mustHaveWords = exports.oneManyWords = exports.splitWithSymbol = exports.fixedIntegerBitNumber = exports.isEmpty = exports.isUndefinedOrEmpty = void 0;
exports.isUndefinedOrEmpty = function (value) {
    return typeof value === "undefined" || exports.isEmpty(value);
};
exports.isEmpty = function (value) {
    if (value === void 0) { value = ""; }
    return /^\s*$/.test(value);
};
exports.fixedIntegerBitNumber = function (value, bit) {
    if (bit === void 0) { bit = 2; }
    if (typeof value === "number") {
        value = "" + value;
    }
    var added = [];
    for (var i = 0; i < bit - value.length; i++) {
        added.push(0);
    }
    return "" + added.join("") + value;
};
exports.splitWithSymbol = function (str, splitSymbol, bit) {
    if (splitSymbol === void 0) { splitSymbol = ","; }
    if (bit === void 0) { bit = 3; }
    var results = [];
    if (typeof str !== "string") {
        str = "" + str;
    }
    var times = 0;
    while (true) {
        var begin = (times + 1) * -1 * bit;
        var end = times === 0 ? str.length : times * -1 * bit;
        var res = str.slice(begin, end);
        if (res === "") {
            break;
        }
        results.unshift(res);
        times++;
    }
    return results.join(splitSymbol);
};
exports.oneManyWords = function (num, oneWords, manyWords) {
    return num === 1 ? oneWords : manyWords;
};
exports.mustHaveWords = function (srcWords, words, gap) {
    if (gap === void 0) { gap = " "; }
    return srcWords.includes(words)
        ? "" + srcWords.replace(words, "").trim() + gap + words
        : "" + srcWords + gap + words;
};
